import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";
import SectionHeader from "components/SectionHeader";
import { ShowMoreBtn } from "components/List";
import EmptyState from "./EmptyState";
import FileDetailModal from "./FileDetailModal";
import IgnoreThreatDialog from "./ThreatRow/IgnoreThreatDialog";
import List from "./List";
import ListSkeleton from "./ListSkeleton";
import Toolbar from "./Toolbar";
import useMalwareList from "./useMalwareList";

export default function MalwareFileList() {
  const { t } = useTranslation("mxheroShares");
  const list = useMalwareList();
  const { state } = list;

  const header = (
    <SectionHeader title={t("malware.title")}>
      <Typography style={{ maxWidth: "75%" }}>
        {t("malware.subtitle")}
      </Typography>
    </SectionHeader>
  );

  if (state.loading && !state.contents) {
    return (
      <>
        {header}
        <ListSkeleton withToolbar />
      </>
    );
  }

  if (state.error && !state.contents) {
    return (
      <>
        {header}
        <Paper
          style={{ padding: "15px 16px" }}
          data-testid="malware-list_error"
        >
          <Typography variant="body2">{t("malware.errors.fetch")}</Typography>
        </Paper>
      </>
    );
  }

  if (state.contents.length === 0 && !state.searchTerm) {
    return (
      <>
        {header}
        <EmptyState />
      </>
    );
  }

  return (
    <>
      {header}
      <Toolbar
        status={state.status}
        counts={list.counts}
        search={state.search}
        onStatusChange={list.setStatus}
        onSearchChange={list.setSearch}
        onSearchSubmit={list.submitSearch}
      />
      {state.loading ? (
        <ListSkeleton />
      ) : (
        <List
          contents={list.visibleContents}
          expandedChecksum={state.expandedChecksum}
          extraFiles={state.extraFiles}
          loadingFilesOf={state.loadingFilesOf}
          onToggle={list.toggle}
          onShowAllFiles={list.showAllFiles}
          onFileClick={list.openFile}
          onRelease={list.startIgnoring}
        />
      )}
      {state.moreToLoad && !state.loading && (
        <Box marginTop="10px">
          <ShowMoreBtn loading={state.loadingMore} onClick={list.loadMore} />
        </Box>
      )}
      {state.openFile && (
        <FileDetailModal
          file={state.openFile.file}
          content={list.openContent}
          onClose={list.closeFile}
        />
      )}
      {state.ignoring && (
        <IgnoreThreatDialog
          content={state.ignoring}
          onClose={list.cancelIgnoring}
          onIgnored={list.ignored}
        />
      )}
    </>
  );
}
